import template from './checkbox.html'

export default function checkboxDirective() {
  return {
    restrict: 'E',
    // 指令比较重要的 scope属性实现与控制器作用域的隔离与交互，反正就是作用域不影响而又可以传参交互
    scope: {
      val: '=', // 这里接受外部的参数 并且实现与外部参数的双向数据交互
      text: '@',
      cbDisable: '=',
      name: '@',
      cbChange: '=',
    },
    template,
    // link complir 这些函数少许区别 可以看下指令api 说明
    link(scope, element) {
      const hash = (() => {
        const arr = []
        for (let i = 0; i < 100; i++) {
          arr.push(Math.floor(Math.random() * 100))
        }
        return arr.join('')
      })()
      scope.hash_id = `checkbox_${hash}` // 不重要的代码只是做随机ID

      scope.onoff = scope.val
      scope.text = scope.text
      scope.cbDisable = scope.cbDisable
      scope.checkboxChange = () => {
        scope.val = scope.onoff
        scope.cbChange && scope.cbChange(scope.onoff, scope.name)
      }
      scope.$watch('val', (newValue) => {
        scope.onoff = newValue
      })
      scope.$watch('cbDisable', (newValue) => {
        scope.cbDisable = newValue
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/checkbox/checkboxDirective.js